import { Input, Select } from "antd";
import countryCodes from "../data/country-phone-codes.json";
import PhoneUtil from "../utils/phone-util";

/**
 * Ülke kodlu telefon girişi — `antd-country-phone-input` paketinin yerine geçer.
 * O paket antd 4.x'e çakılıydı (peer: antd 4.x) ve v5 ile test edilmemişti; ayrıca çalışması için
 * ConfigProvider'a locale olarak ülke listesi geçirmeyi zorunlu kılıyordu (antd'nin gerçek locale'ini bozan bir hack).
 *
 * Form değeri v4'teki ile BİREBİR aynı: { code: number, phone: string }
 * → UserCreateEdit'teki `${phone.code}-${clearPhoneFormat(phone.phone)}` kaydetme mantığı değişmedi.
 */
const options = countryCodes.map((c) => ({
    value: c.code,
    label: `${c.emoji} +${c.code}`,
    title: `${c.name} (+${c.code})`,
    search: `${c.name} ${c.short} ${c.code}`.toLowerCase(),
}));

export default function PhoneInput({ value = {}, onChange, disabled, ...rest })
{
    const emit = (next) => onChange?.({ ...value, ...next });

    return (
        <Input
            {...rest}
            disabled={disabled}
            value={value.phone}
            onChange={(e) => emit({ phone: PhoneUtil.phoneFormat(e.target.value) })}
            addonBefore={
                <Select
                    showSearch
                    disabled={disabled}
                    value={value.code}
                    onChange={(code) => emit({ code })}
                    options={options}
                    optionFilterProp="search"
                    filterOption={(input, option) => option.search.includes(input.toLowerCase())}
                    style={{ width: 110 }}
                    popupMatchSelectWidth={280}
                />
            }
        />
    );
}
